import axiosInstance from "./AxiosInstanceMain"; 
// 🔥 CREATE BUILDER
export const createBuilderApi = async (data) => {
  try {
    const res = await axiosInstance.post("/builders/create", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 GET ALL BUILDERS (WITH SEARCH + PAGINATION)
export const getBuildersApi = async (params) => {
  try {
    const res = await axiosInstance.get("/builders/getAll", {
      params,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 GET BUILDER BY ID
export const getBuilderByIdApi = async (id) => {
  try {
    const res = await axiosInstance.get(`/builders/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 UPDATE BUILDER
export const updateBuilderApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(`/builders/${id}`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 DELETE BUILDER (SOFT DELETE)
export const deleteBuilderApi = async (id) => {
  try {
    const res = await axiosInstance.delete(`/builders/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 REACTIVATE BUILDER
export const reactivateBuilderApi = async (id) => {
  try {
    const res = await axiosInstance.put(`/builders/reactivate/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 GET INACTIVE BUILDERS
export const getInactiveBuildersApi = async (params) => {
  try {
    const res = await axiosInstance.get(`/builders/inactive`, {
      params,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};